import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseScadaNode from './BaseScadaNode';
import { PackagerSingleSVG } from './PackagerSingleNode';

export default function PackagerMultiNode(props) {
    const { data } = props;
    const { t } = useTranslation();
    const lanes = data?.config?.lanes || 4;
    const w = data?.width || Math.max(80, lanes * 22);
    const h = data?.height || 100;
    const liveValues = data?.liveValues || {};
    const threshold  = parseFloat(data?.config?.threshold ?? 0.5);
    const requesting = liveValues.requesting_product != null
        && parseFloat(liveValues.requesting_product) >= threshold;
    const bufferEmpty = !!liveValues._packagerBufferEmpty;
    const running = parseFloat(liveValues.state ?? 0) >= threshold;
    return (
        <BaseScadaNode {...props}>
            <PackagerSingleSVG
                value={liveValues.state ?? data?.liveValue}
                config={data?.config}
                width={w}
                height={h}
                lanes={lanes}
            />
            {running && bufferEmpty && (
                <div style={{ position: 'absolute', top: 4, left: 4, right: 4, background: '#7F1D1D',
                    border: '1px solid #EF4444', borderRadius: 4, padding: '2px 4px',
                    fontSize: 9, color: '#FCA5A5', textAlign: 'center', fontWeight: 600,
                    pointerEvents: 'none', zIndex: 5 }}>
                    {t('scada.noProduct')}
                </div>
            )}
            {running && requesting && !bufferEmpty && (
                <div style={{ position: 'absolute', top: 4, left: 4, right: 4, background: '#92400E',
                    border: '1px solid #F59E0B', borderRadius: 4, padding: '2px 4px',
                    fontSize: 9, color: '#FEF3C7', textAlign: 'center', fontWeight: 600,
                    pointerEvents: 'none', zIndex: 5 }}>
                    {t('scada.sig.requestingProduct')}
                </div>
            )}
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
